import {Container} from "../core/Container";
import {Callback} from "../core/Reflection";
import {OnboardingStep} from "../data/OnboardingStep";
import {PersistentGameModel} from "../data/PersistentGameModel";
import {voOnboarding, voOptionsOnboarding} from "../data/VoiceOver";
import {Analytics} from "../managers/Analytics";
import {CaptionManager} from "../managers/CaptionManager";
import {VoiceOverManager} from "../managers/VoiceOverManager";
import {OnboardingArrow} from "./OnboardingArrow";

export class OnboardingContainer extends Container {

    private _currentStep: OnboardingStep = OnboardingStep.None;

    public showOnboardingStep(step: OnboardingStep, parent: Container, arrows: Array<{ x: number, y: number, d: "up" | "down" | "left" | "right" }>, cb?: Callback) {
        if (this._currentStep > OnboardingStep.None) {
            return false;
        }
        if (PersistentGameModel.getOnboardingStep() < step && VoiceOverManager.instance.active) {
            PersistentGameModel.setOnboardingStep(step);

            if (step === OnboardingStep.SwitchLocation) {
                Analytics.event("tutorial_begin");
            }
            if (step === OnboardingStep.GoHome) {
                Analytics.event("tutorial_complete");
            }

            const onboardingArrows: OnboardingArrow[] = [];
            for (const a of arrows) {
                const arrow = this.addChild(new OnboardingArrow());
                const p = this.toLocal(new PIXI.Point(a.x, a.y), parent);
                arrow.x = p.x;
                arrow.y = p.y;
                arrow.rotation = a.d === "up" ? Math.PI * 0.5 :
                    a.d === "down" ? -Math.PI * 0.5 :
                        a.d === "left" ? 0 : Math.PI;
                onboardingArrows.push(arrow);
            }
            const vo = voOnboarding[step];
            if (vo) {
                this._currentStep = step;
                VoiceOverManager.instance.playVO(vo, voOptionsOnboarding);
                const d = CaptionManager.instance.getDuration(vo);
                this.delayedCall(d, () => {
                    for (const arrow of onboardingArrows) {
                        arrow.hide();
                    }
                    this._currentStep = OnboardingStep.None;
                    if (cb) {
                        cb();
                    }
                });
                return true;
            }
        } else if (cb) {
            cb();
        }
        return false;
    }

    public hideOnboardingStep() {
        VoiceOverManager.instance.stopVO();
        for (const arrow of this.getChildren()) {
            if (arrow instanceof OnboardingArrow) {
                arrow.hide();
            }
        }
    }
}
